import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "@/features/auth/authConfig";

export const msalClient = new PublicClientApplication(msalConfig);
